import React from 'react';
import { History } from 'history';
import { Input, InputEmail, InputFile, InputMultiline, InputSelect, InputSwitch, InputPicklist } from '../../components';
import BaseEdit from '../base/base-edit.component'; 
import Model from './message-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import AppService from '../../services/app.service';
import OwnerPicklist from '../owner/owner-picklist.component';

interface IProps { 
    history: History;
    caption?: string;
    astemplate?: string;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
}

export default class MessageEdit extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMedia: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }
    
    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }

    private onLoadFile = (data: any) => {
        this.setState({
            datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow: {id: this.state.datarow.attachmentId, files: data, ref: Model.endPointMedia, field:'attachment'}},
        });
    }
   
    private onError = (data: any) => {
        this.setState({errors: data});
    }

    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseEdit history={this.props.history} caption={this.props.caption} 
                model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} onLoad={this.onLoad} onError={this.onError}>              
                                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                }
                <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} error={this.state.errors?.type} onChange={this.onChange} />
                {this.props.astemplate!=='yes' &&
                <InputSwitch name='sent' label='Sent' value={this.state.datarow.sent} error={this.state.errors?.sent} onChange={this.onChange}/>
                }
                {this.state.datarow.type==='email'?
                <>
                <InputEmail name='to' label='To' value={this.state.datarow.to} error={this.state.errors?.to} onChange={this.onChange} />
                <InputEmail name='cc' label='Cc' value={this.state.datarow.cc} error={this.state.errors?.cc} onChange={this.onChange} />
                <InputEmail name='bcc' label='Bcc' value={this.state.datarow.bcc} error={this.state.errors?.bcc} onChange={this.onChange} />
                <InputEmail name='replyto' label='Reply to' value={this.state.datarow.replyto} error={this.state.errors?.replyto} onChange={this.onChange} />
                </>
                : 
                <Input name='to' label='To' value={this.state.datarow.to} error={this.state.errors?.to} onChange={this.onChange} />
                }
                <Input name='subject' label='Subject' value={this.state.datarow.subject} error={this.state.errors?.subject} onChange={this.onChange} />
                <InputMultiline name='text' label='Text' value={this.state.datarow.text} error={this.state.errors?.text} onChange={this.onChange} />
                <InputFile name='attachmentUrl' label='Attachment' value={this.state.datarow.attachmentUrl} onLoad={this.onLoadFile} encode error={this.state.errors?.attachment} onChange={this.onChange} />
            </BaseEdit>
        );
    }
}